window.components = {
  ...window.components,
  'Avatar': require('../components/Avatar'),
  'AvatarEditor': require('../components/AvatarEditor'),
}

window.mountComponents(window.components);
